var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollDownWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.3714 25.1758L20.0098 32.8143L27.6483 25.1758C28.4161 24.408 29.6564 24.408 30.4242 25.1758C31.1919 25.9436 31.1919 27.1839 30.4242 27.9517L21.3879 36.9879C20.6201 37.7557 19.3799 37.7557 18.6121 36.9879L9.57584 27.9517C8.80805 27.1839 8.80805 25.9436 9.57584 25.1758C10.3436 24.4277 11.6036 24.408 12.3714 25.1758V25.1758Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.3714 3.57584L20.0098 11.2143L27.6483 3.57584C28.4161 2.80805 29.6564 2.80805 30.4242 3.57584C31.1919 4.34362 31.1919 5.58389 30.4242 6.35168L21.3879 15.3879C20.6201 16.1557 19.3799 16.1557 18.6121 15.3879L9.57584 6.35168C8.80805 5.58389 8.80805 4.34362 9.57584 3.57584C10.3436 2.82774 11.6036 2.80805 12.3714 3.57584V3.57584Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.6507 14.5717L20.2891 22.2102L27.9276 14.5717C28.6954 13.8039 29.9357 13.8039 30.7035 14.5717C31.4712 15.3395 31.4712 16.5797 30.7035 17.3475L21.6672 26.3838C20.8994 27.1516 19.6592 27.1516 18.8914 26.3838L9.85514 17.3475C9.08735 16.5797 9.08735 15.3395 9.85514 14.5717C10.6229 13.8236 11.8829 13.8039 12.6507 14.5717V14.5717Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDownWhite);
export default __webpack_public_path__ + "static/media/ScrollDownWhite.64fd85407d01fd05db1ae51c731756bc.svg";
export { ForwardRef as ReactComponent };